import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import cN from 'classnames';
import styles from './styles.module.scss';
import { filterTypesKey, I_FilterItem } from '@Redux/search/interfaces';
import {
    setFilterItems,
    setTempFilterItems,
    setDepthinfo,
    setTagFiltersShow,
    setTempTagFiltersShow,
} from '@Redux/search/actions';
import { RootState } from '@Redux/search/store';
import { TagsFilter } from '@components/Common/Icons';
import SlideFooter from '@components/Common/SlideFooter';
import SlidePage from '@components/Common/SlidePage';
import FiltersBlock from './subComponent/FiltersBlock';
import dayjs from 'dayjs';

interface TagFiltersProps {
    onConfirm: (finalItems: I_FilterItem[]) => void; // M版按確認後
}

const TagFilters: React.FC<TagFiltersProps> = () => {
    const { FilterItems, TempFilterItems, DepthInfo, TagFiltersShow, TempTagFiltersShow } =
        useSelector((state: RootState) => state.search);

    const curPage = location.pathname;

    const [visible, setVisible] = useState(false);
    const isMobile = useMediaQuery({ query: '(max-width: 980px)' });
    const dispatch = useDispatch();
    const moduleName = 'tagfilters';

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);

        const GoDateEnd = (() => {
            // 如果是旅遊館群，最晚出發日為多 1 年
            if (urlParams.get('TravelPavilionGroupID')) {
                return dayjs().add(3, 'year').format('YYYY-MM-DD');
            } else {
                return urlParams.get('GoDateEnd') || dayjs().add(30, 'days').format('YYYY-MM-DD');
            }
        })();

        const toBoolean = (parm: string | null) => {
            if (parm == 'true') {
                return true;
            } else if (parm == 'false') {
                return false;
            } else {
                return null;
            }
        };

        const reqDepthInfoBody = {
            DepartureID: urlParams.get('DepartureID') || '',
            ArriveID: urlParams.get('ArriveID') || '',
            GoDateStart: urlParams.get('GoDateStart') || dayjs().format('YYYY-MM-DD'),
            GoDateEnd,
            GroupID: urlParams.get('GroupID') || '',
            Keywords: urlParams.get('Keywords') || '',
            IsEnsureGroup: toBoolean(urlParams.get('IsEnsureGroup')),
            IsSold: toBoolean(urlParams.get('IsSold')),
            TravelType: urlParams.get('TravelType') || 1,
            ThemeID: urlParams.get('ThemeID') || null,
            TravelPavilionGroupID: urlParams.get('TravelPavilionGroupID') || null,
        };

        if (!DepthInfo) dispatch(setDepthinfo(reqDepthInfoBody));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [curPage]);

    // 完全沒有標籤的情況
    const noTagFilter =
        DepthInfo?.CategoryList.length === 0 && DepthInfo?.TripTypeList.length === 0;

    return DepthInfo?.CategoryList ? (
        <div
            className={cN(`${moduleName}_wrapper`, styles[`${moduleName}_wrapper`], {
                [`${styles.noTagFilter}`]: noTagFilter,
            })}
        >
            <div
                className={cN(moduleName, styles[moduleName], {
                    [`${styles.noTagFilter}`]: noTagFilter,
                })}
            >
                {isMobile ? (
                    <div className={styles[`${moduleName}_M`]}>
                        <div
                            className={cN(styles.ToggleSliderBtn)}
                            onClick={() => setVisible(true)}
                            data-cy="toggle_m_tags"
                        >
                            <div className={cN(styles.BtnIcon)}>
                                <TagsFilter fill="#669" />
                            </div>
                            <div className={cN(styles.BtnText)}>
                                <span>特色標籤，探索行程！..GO</span>
                            </div>
                        </div>
                        <SlidePage
                            title="團體特色標籤"
                            visible={visible}
                            setIsVisible={() => {
                                setVisible(false);
                                dispatch(setFilterItems(TempFilterItems));
                                dispatch(setTagFiltersShow(TempTagFiltersShow));
                            }}
                        >
                            <>
                                <FiltersBlock />
                                <SlideFooter
                                    onClickLeftBtn={() => {
                                        const notTagFiltersItems = FilterItems.filter(
                                            (item: I_FilterItem) =>
                                                item.filterBy !== filterTypesKey.CategoryList
                                        );
                                        dispatch(setFilterItems(notTagFiltersItems));
                                        dispatch(setTagFiltersShow([]));
                                    }}
                                    onClickRightBtn={() => {
                                        setVisible(false);
                                        dispatch(setTempTagFiltersShow(TagFiltersShow));
                                        dispatch(setTempFilterItems(FilterItems));
                                    }}
                                    leftBtnText="重設條件"
                                    rightBtnText="確定"
                                />
                            </>
                        </SlidePage>
                    </div>
                ) : (
                    <FiltersBlock />
                )}
            </div>
        </div>
    ) : (
        <div className={styles.empty} />
    );
};

export default TagFilters;
